import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { VISIBILITY } from './core/btn-visibility.model';

@Component({
  selector: 'btn-visibility',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './btn-visibility.component.html',
  styleUrl: './btn-visibility.component.scss',
})
export class BtnVisibilityComponent {
  VISIBILITY = VISIBILITY;

  @Output() statusChange = new EventEmitter<VISIBILITY>();
  status = VISIBILITY.NONE;

  toggle() {
    this.status === this.VISIBILITY.VISIBLE
      ? (this.status = this.VISIBILITY.NONE)
      : (this.status = this.VISIBILITY.VISIBLE);

    this.statusChange.emit(this.status);
  }
}
